import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "app/lib/helper.service";
import {ChartParams} from "../../views/chart/chart.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {TemplateTagDetailsComponent} from "./details/details.component";
import { TemplateService } from "../template.service";
import { UserService } from "../../user/user.service";
import { ITotals } from "../../models/responce_result.model";

interface ITemplateTagTotals extends ITotals {
	totalCount: number;
	queryCount: number;
}

@Component({
	selector: 'template-tag',
	templateUrl: './template_tag.component.html'
})
export class TemplateTagComponent extends BaseComponent {
	statsLoader: boolean = false;

	type: string = 'all';
	
	stats = [];
	totalCount: number = 0;
	queryCount: number = 0;
	
	chart = new ChartParams();
	chartCompletedRegistrations = new ChartParams();

	addFilterParams = {
		userType: 'user',
		isTemplateTag: true,
		dateFilters : ['dateTemplateTag', 'dateCreated', 'datePaid']
	};

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService, 
		public modalService: ModalService,
		public http: HttpClient,
		public helper: HelperService,
		public templateService: TemplateService,
		public userService: UserService 
	) {
		super(eventsService, templateService, activatedRoute, filter, translate);

		this.chartCompletedRegistrations.setOptions({
			names: {'completedRegistrations': 'Завершенные регистрации'},
			axis: {
				y: {
					show: true,
					max: 100,
					tick: {
						format: function (y) {
							return y + '%';
						}
					}
				}
			},
			tooltip: {
				format: {
					value: value => value + '%'
				}
			}
		})
	}

	async getData() {
		await this.getChart();
		await this.getStats();
		await this.getTotals();
	}
	

	async getChart() {
		this.chart.showLoader();
		this.chartCompletedRegistrations.showLoader();

		const { charts } = await this.userService.reg_day.chart(
			this.filter.filterParams
		).toPromise();
		
		// Ниже какая-то дичь, ибо нам нужно:
		// 1. получить метрку из графика reg_day, но не просто метрику,
		// 	а отношение usersWithSite к countReg в процентах
		// 2. запихнуть это в виде график
		// И reduce не компилиться,
		// поскольку начальное значение массива первым элементов содержить строку, а остальые - числа.
		// И хуй переубедишь
		const countReg = charts.find(c => c[0] === 'countReg');
		const usersWithSite = charts.find(c => c[0] === 'usersWithSite');
		
		const newCharts: (string | number)[] = ['completedRegistrations'];
		for(let i=1; i<charts[0].length; i++) {
			const percent = <number>usersWithSite[i] / <number>countReg[i];

			newCharts.push(
				isNaN(percent) ? 0 : Math.floor(percent * 100)
			)
		}
		
		this.chartCompletedRegistrations.data = [
			charts[0],
			newCharts
		];
		this.chartCompletedRegistrations.hideLoader();

		const { charts: _charts } = await this.templateService.tag.chart(
			this.filter.filterParams
		).toPromise();
		this.chart.data = _charts;
		this.chart.hideLoader();
	}
	

	async getStats() {
		this.statsLoader = true;

		const { stats } = await this.templateService.tag.stats(
			{ ...this.filter.filterParams, showType: this.type, }
		).toPromise();
		this.stats = stats;

		this.statsLoader = false;
	}
	
	async changeType() {
		if (this.type == 'all') {
			this.type = 'not_found';
		} else {
			this.type = 'all';
		}

		await this.getStats();
	}
	
	async showDetails(searchQuery: string) {
		const modalRef = this.modalService.open(TemplateTagDetailsComponent, {
			title: searchQuery,
		}, {size: 'hg'});

		const { stats } = await this.templateService.tag.detail(
			{ ...this.filter.filterParams, showType: this.type, searchQuery, }
		).toPromise();

		modalRef.componentInstance.details = stats;
	}

	async getTotals() {
		const { totalCount, queryCount, } = await this.templateService.tag.total<ITemplateTagTotals>(
			this.filter.filterParams
		).toPromise();

		this.totalCount = totalCount;
		this.queryCount = queryCount;
	}
}
